import LogoSvg from "@/src/svg/default/LogoSvg";
import LoginForm from "./LoginForm/LoginForm";
import "./style.scss";

const LoginLayout = () => {
  return (
    <div className="login-page">
      <div className="login-title">
        <div className="login-title-svg">
          <LogoSvg />
        </div>
        <div className="login-title-line"></div>
        <div className="login-title-text">
          <p>Platforma</p>
        </div>
      </div>
      <LoginForm />
    </div>
  );
};

export default LoginLayout;
